import * as React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@hooks/useAuth';

/**
 * Route guard for admin-only screens.
 * Requires `has_extra_options` flag on the user profile (server-controlled admin flag).
 * Must be nested inside <ProtectedRoute> which handles the auth loading spinner.
 */
export const AdminRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return null;
  }

  if (!user?.has_extra_options) {
    return <Navigate to="/settings" replace />;
  }

  return <>{children}</>;
};
